module.exports = __webpack_public_path__ + "img/dot.82bb93db.svg";